import { useViewport } from '@chilecompra/react-kit'
import { Button, Toast } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'

import { Container, Divider } from '../Claims.styles'

/**
 * The ClaimsActions component.
 */
const ClaimsActions = ({ isDisabled = false, onBack, onSubmit, submitError }) => {
  const { size } = useViewport()

  const isTiny = size.isTiny

  return (
    <Container direction="column" spacing={4}>
      <Divider />

      {submitError && (
        <Toast
          border
          severity="error"
          textDirection="vertical"
          title="Lo sentimos, estamos presentando problemas con nuestro servidor."
        >
          En estos momentos tenemos problemas para disponibilizar la información. Por favor,
          consulta en unos minutos más.
        </Toast>
      )}

      <Container
        alignItems="center"
        direction={isTiny ? 'column' : 'row'}
        justifyContent={isTiny ? 'center' : 'space-between'}
        spacing={2}
      >
        <Button
          color="primary"
          disabled={isDisabled}
          onClick={onBack}
          padding="0 16px"
          variant="outlined"
          width={isTiny ? '100%' : '200px'}
        >
          Volver
        </Button>

        <Button
          color={submitError ? 'error' : 'primary'}
          disabled={isDisabled}
          onClick={onSubmit}
          padding="0 16px"
          variant={submitError ? 'outlined' : 'contained'}
          width={isTiny ? '100%' : '200px'}
        >
          {submitError ? 'Reintentar' : 'Enviar'}
        </Button>
      </Container>
    </Container>
  )
}

ClaimsActions.propTypes = {
  isDisabled: PropTypes.bool,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitError: PropTypes.bool
}

export default ClaimsActions
